var rellax = new Rellax('.rellax');

var rellax = new Rellax('.rellax--center', {
    center:true
  });